export default "__VITE_ASSET__Dn09YOSd__"